module.exports = __webpack_public_path__ + "img/image-2.743b93a1.jpg";